@if (data.icon) {
  <div class="mark-cdr-snack-bar__icon" [class]="data.icon.action">
    @switch (data.icon.custom) {
      @case (true) {
        <mat-icon [svgIcon]="data.icon.name" [style.color]="data.icon.color ? data.icon.color : ''"></mat-icon>
      }
      @default {
        <mat-icon [style.color]="data.icon.color ? data.icon.color : ''">{{ data.icon.name }}</mat-icon>
      }
    }
  </div>
}
<div class="mark-cdr-snack-bar__text" matSnackBarLabel>{{ data.labelKey | lang: data.text }}</div>
<div matSnackBarActions class="mark-cdr-snack-bar__actions">
  @if (data.closeButton) {
    <mat-icon class="mark-cdr-snack-bar__actions__close" matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      close
    </mat-icon>
  }
</div>
